import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table, Button, Modal, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrashAlt,
    faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import { COLOR_APP } from '../../../constants'
import moment from "moment";
import { convertOrderStatus } from "../../../helpers/orderStatus";
import { thousandSeperate } from "../../../helpers";
import { GET_ORDERS } from "../../../graphql/order/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { DELETE_ORDER, UPDATE_ORDER } from "../../../graphql/order/mutation";
import AnimationLoading from "../../../components/AnimationLoading";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import { UPDATE_POST_STOCK } from "../../../graphql/postStock/mutation";

function PostDetailCFWithUser() {
    const { history, location, match } = useReactRouter()
    const LOCAL_DATA = location.state
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleteOrder, setIsDeleteOrder] = useState(false);
    const [deleteData, setDeleteData] = useState();
    const [orders, setOrders] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [stockMessages, setStockMessages] = useState('');
    const [showUpdateStatus, setShowUpdateStatus] = useState(false);
    const [orderStatus, setOrderStatus] = useState("")

    const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    const [deleteOrder] = useMutation(DELETE_ORDER);
    const [updateOrder] = useMutation(UPDATE_ORDER);
    const [updateStock] = useMutation(UPDATE_STOCK)
    const [updatePostStock] = useMutation(UPDATE_POST_STOCK)

    useEffect(() => {
        funcGetData()
    }, [])

    const funcGetData = async () => {
        const SHOP_ID = await localStorage.getItem("SHOP");
        getOrderData({
            variables: {
                where: {
                    cfName: LOCAL_DATA?.cfName ?? "",
                    post: LOCAL_DATA?.orders[0]?.post?.id,
                    shop: SHOP_ID,
                    isDeleted: false
                },
                skip: 0,
                limit: 1000,
                orderBy: "createdAt_DESC"
            }
        })
    }

    useEffect(() => {
        if (orderData?.orders?.data) {
            setOrders(orderData?.orders?.data)
            let _totalPrice = 0
            let _stockMessage = ''
            for (var i = 0; i < orderData.orders.data?.length; i++) {
                _totalPrice += orderData.orders.data[i]?.totalPrice
                _stockMessage = _stockMessage + (_stockMessage != '' ? ', ' : '') + orderData.orders.data[i]?.postStock?.cfMessage
            }

            let _orderToPrint = []
            const orderGroup = _.groupBy(orderData.orders.data, "postStock.cfMessage")
            for (let [cfMessage, values] of Object.entries(orderGroup)) {
                let count = 0
                let price = 0
                let name = ""
                for (var i = 0; i < values.length; i++) {
                    count += (values[i].amount ?? 1)
                    price += (values[i].totalPrice ?? 0)
                    let value = ""
                    if (values[i]?.postStock?.stock?.optionValues.length > 0) {
                        for (var j = 0; j < values[i].postStock.stock.optionValues.length; j++) {
                            value = value + " " + values[i].postStock.stock.optionValues[j]?.value
                        }
                    }

                    name = values[0]?.postStock?.stock?.name + " " + value
                }
                _orderToPrint.push({
                    cfMessage,
                    count,
                    price,
                    name,
                })
            }

            setTotalPrice(_totalPrice)
            setStockMessages(_stockMessage)
        }
    }, [orderData])

    const onDeleteOrder = async (order) => {
        setDeleteData(order)
        setIsDeleteOrder(true)
    }

    const _deleteOrder = async () => {
        try {
            let _deleteOrder = await deleteOrder({
                variables: {
                    where: {
                        id: deleteData.id
                    }
                }
            })
            if (_deleteOrder?.data?.deleteOrder) {
                updatePostStock({
                    variables: {
                        where: {
                            id: deleteData?.postStock?.id
                        },
                        data: {
                            amount: deleteData?.postStock?.amount + deleteData?.amount
                        }
                    }
                })
                updateStock({
                    variables: {
                        where: {
                            id: deleteData?.postStock?.stock?.id
                        },
                        data: {
                            amount: deleteData?.postStock?.stock?.amount + deleteData?.amount
                        }
                    }
                })
            }

            funcGetData()
            setIsDeleteOrder(false)
        } catch (error) {
            setIsDeleteOrder(false)
            console.log("error: ", error)
        }
    }

    const onUpdateOrderStatus = async () => {
        try {
            setIsLoading(true)
            let _dataForUpdate = []
            for (var i = 0; i < orders.length; i++) {
                await _dataForUpdate.push(orders[i].id);
            }

            setShowUpdateStatus(false)
            if (orderStatus && _dataForUpdate.length > 0) {
                for (var i = 0; i < _dataForUpdate.length; i++) {
                    await updateOrder({
                        variables: {
                            where: {
                                id: _dataForUpdate[i]
                            },
                            data: {
                                status: orderStatus
                            }
                        }
                    })
                }
            }
            setOrderStatus("")
            funcGetData()
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }

    return (
        <div>
            {isLoading ? <AnimationLoading /> : <div />}
            <div style={{ background: "#eee", borderRadius: 5, padding: 15, position: "relative" }}>
                <p style={{ margin: 0, fontSize: 24, fontWeight: "bold" }}>ຂໍ້ມູນການສັ່ງ</p>
                <p style={{ margin: 0 }}>ຜູ້ສັ່ງ : {LOCAL_DATA?.cfName ?? ''}</p>
                <p style={{ margin: 0 }}>ຈຳນວນການສັ່ງ : {thousandSeperate(orders?.length ?? 0)}</p>
                <p style={{ margin: 0 }}>ລວມເງິນ : {thousandSeperate(totalPrice ?? 0)}</p>
                <p style={{ margin: 0 }}>ລະຫັດສິນຄ້າທີ່ສັ່ງ : {stockMessages ?? ''}</p>
                <p style={{ margin: 0 }}>ວັນທີ : {moment(LOCAL_DATA?.createdAt).format('HH:mm DD/MM/YYYY')}</p>
                <div style={{ position: "absolute", top: 10, right: 25, background: COLOR_APP, padding: 10, borderRadius: 5 }}>
                    <p style={{ color: "#fff", fontSize: 24, margin: 0 }}>{convertOrderStatus(orders[0]?.status)} </p>
                </div>
            </div>
            <div style={{ height: 15 }} />
            <div className="row" style={{ margin: 0 }}>
                {/* <div className="col-3" style={{ float: "left", paddingLeft: 10, paddingTop: 3, background: "green", color: "#fff" }}>
                    <FontAwesomeIcon icon={faFileAlt} />
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="btn btn-app hoverme text-white"
                        table="table-to-xls"
                        filename={"Orders-live-detail-" + (new Date().toISOString())}
                        sheet="Orders"
                        buttonText="ດາວໂຫຼດເອັກເຊວ"
                    />
                </div>
                <div style={{ width: 24 }} />
                <button className="btn btn-app hoverme col-3"
                    style={{ float: "left", background: COLOR_APP, color: "#fff" }}
                    onClick={() => setShowUpdateStatus(true)}
                >
                    <FontAwesomeIcon icon={faFileAlt} />  ອັບເດດສະຖານະ
                </button> */}
                {/* <div style={{ width: 24 }} />
                <ReactToPrint
                    trigger={() => <button className="btn btn-app hoverme col-3"
                        style={{ float: "left", background: COLOR_APP, color: "#fff" }}
                    >
                        <FontAwesomeIcon icon={faPrint} /> Print
                    </button>}
                    content={() => componentRef.current}
                /> */}
            </div>
            {/* <div style={{ display: 'none' }}>
                <OrderBill ref={componentRef} data={orderToPrint} />
            </div> */}
            <div style={{ height: 10 }} />
            {orders?.length > 0 && <Table responsive className="staff-table-list borderless table-hover">
                <thead style={{ background: "#F1F1F1" }}>
                    <tr>
                        <th>ລຳດັບ</th>
                        <th>ສິນຄ້າ</th>
                        <th>ລະຫັດ</th>
                        <th>ລາຄາ</th>
                        <th>ຈຳນວນ</th>
                        <th>ລວມເປັນເງິນ</th>
                        <th>ຂໍ້ຄວາມ</th>
                        <th>ເວລາ</th>
                        <th>ຈັດການ</th>
                    </tr>
                </thead>
                <tbody>
                    {orders?.length > 0 &&
                        orders?.map((order, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                    <pre style={{ fontWeight: "bold", fontSize: 14, margin: 0 }}>
                                        {order?.postStock?.stock?.name}
                                    </pre>
                                    {order?.postStock?.stock?.optionValues?.length > 0 &&
                                        order?.postStock?.stock?.optionValues.map((dd, kIndex) => <pre key={"option" + kIndex + index} style={{ margin: 0, fontSize: 12 }}>{dd.name + ':' + dd.value}</pre>)
                                    }
                                </td>
                                <td>{order?.postStock?.cfMessage ?? ""}</td>
                                <td>{thousandSeperate(order?.price ?? 0)}</td>
                                <td>{thousandSeperate(order?.amount ?? 1)}</td>
                                <td>{thousandSeperate(order?.totalPrice ?? order?.price)}</td>
                                <td>{order?.message ?? ""}</td>
                                <td>{moment(order?.createdAt).format('HH:mm DD/MM/YYYY')}</td>
                                <td className="row col-12" style={{ margin: 0 }}>
                                    <button className="btn hoverme col-5" onClick={() => onDeleteOrder(order)} >
                                        <FontAwesomeIcon icon={faTrashAlt} style={{ color: "red" }} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>}

            {orders?.length > 0 && <Table id="table-to-xls" style={{ display: "none" }} responsive className="staff-table-list borderless table-hover">
                <thead style={{ background: "#F1F1F1" }}>
                    <tr>
                        <th>ລຳດັບ</th>
                        <th>ຜູ້ສັ່ງ</th>
                        <th>ສິນຄ້າ</th>
                        <th>ລະຫັດ</th>
                        <th>ລາຄາ</th>
                        <th>ຈຳນວນ</th>
                        <th>ລວມເປັນເງິນ</th>
                        <th>ຂໍ້ຄວາມ</th>
                        <th>ເວລາ</th>
                        <th>ສະຖານະ</th>
                    </tr>
                </thead>
                <tbody>
                    {orders?.length > 0 &&
                        orders?.map((order, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{order?.cfName ?? ""}</td>
                                <td>
                                    <pre style={{ fontWeight: "bold", fontSize: 14, margin: 0 }}>
                                        {order?.postStock?.stock?.name}
                                    </pre>
                                    {order?.postStock?.stock?.optionValues?.length > 0 &&
                                        order?.postStock?.stock?.optionValues.map((dd, kIndex) => <pre key={"option" + kIndex + index} style={{ margin: 0, fontSize: 12 }}>{dd.name + ':' + dd.value}</pre>)
                                    }
                                </td>
                                <td>{order?.postStock?.cfMessage ?? ""}</td>
                                <td>{order?.price ?? 0}</td>
                                <td>{order?.amount ?? 1}</td>
                                <td>{order?.totalPrice ?? order?.price}</td>
                                <td>{order?.message}</td>
                                <td>{moment(order?.createdAt).format('HH:mm DD/MM/YYYY')}</td>
                                <td>{convertOrderStatus(order?.status)}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>}

            <Modal show={isDeleteOrder} onHide={() => setIsDeleteOrder(false)}>
                <Modal.Header closeButton>
                    <div>ຢືນຢັນການລຶບ</div>
                </Modal.Header>
                <Modal.Body style={{ padding: 24, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "100%" }}>
                    <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 90, color: "orange" }} />
                    <br />
                    <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບ Order ນີ້ແທ້ບໍ່?</h5>
                </Modal.Body>
                <Modal.Footer style={{ display: "flex", flexDirection: "row", justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="outline-dark"
                        className="btn btn-app hoverme"
                        style={{ width: 150 }}
                        onClick={() => setIsDeleteOrder(false)}
                    >
                        ກັບຄືນ
                    </Button>
                    <div style={{ width: 24 }} />
                    <button
                        className="btn btn-app hoverme"
                        style={{ float: "left", background: "red", color: "#fff", width: 150 }}
                        onClick={() => _deleteOrder()}
                    >
                        ລຶບ
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showUpdateStatus} onHide={() => setShowUpdateStatus(false)} size={"lg"}>
                <Modal.Header closeButton>
                    <div>ເລືອກສະຖານະ </div>
                </Modal.Header>
                <Modal.Body style={{ padding: 0 }}>
                    <ListGroup>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("CREATED")}
                            style={orderStatus == "CREATED" ? { background: COLOR_APP, color: "#fff" } : { background: '#f9f9f9' }}
                        >ອໍເດີ້ສໍາເລັດ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("READYTOSHIP")}
                            style={orderStatus == "READYTOSHIP" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ກະກຽມຈັດສົ່ງ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("SHIPPING")}
                            style={orderStatus == "SHIPPING" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ກໍາລັງສົ່ງ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("SHIPPING_COMPLETED")}
                            style={orderStatus == "SHIPPING_COMPLETED" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ສົ່ງສໍາເລັດ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("COMPLETED")}
                            style={orderStatus == "COMPLETED" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ສໍາເລັດບໍລິການ</ListGroup.Item>
                        <ListGroup.Item
                            className="hoverme"
                            onClick={() => setOrderStatus("CANCELLED")}
                            style={orderStatus == "CANCELLED" ? { background: COLOR_APP, color: "#fff", marginTop: 1 } : { background: '#f9f9f9', marginTop: 1 }}
                        >ຍົກເລີກ</ListGroup.Item>
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer style={{ display: "flex", flexDirection: "row", justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="outline-dark"
                        className="btn btn-app hoverme"
                        style={{ width: 150 }}
                        onClick={() => {
                            setShowUpdateStatus(false)
                            setOrderStatus("")
                        }}
                    >
                        ກັບຄືນ
                    </Button>
                    <div style={{ width: 24 }} />
                    <button
                        className="btn btn-app hoverme"
                        style={{ float: "left", background: COLOR_APP, color: "#fff", width: 150 }}
                        onClick={() => onUpdateOrderStatus()}
                    >
                        ອັບເດດ
                    </button>
                </Modal.Footer>
            </Modal>
        </div >
    );
}

export default PostDetailCFWithUser;